import type { DigitalPublicationOption } from '../api/get-digital-publication-options.server';

/**
 * The four series the site offers, in the order they are shown. The
 * catalogue can carry more — HubSpot lists every subscription type — but
 * these are the publications, on the directory's row and in the subscribe
 * gate alike.
 */
export const DIGITAL_PUBLICATION_SERIES = [
    'Curated Collection',
    'Build',
    'The Project Portfolio',
    'Commercial Edit',
];

/** The catalogue narrowed to the four series, one each, in their order. */
export const onlyPublicationSeries = (
    publications: DigitalPublicationOption[],
): DigitalPublicationOption[] =>
    DIGITAL_PUBLICATION_SERIES.flatMap((series) => {
        const match = publications.find(
            (publication) => publication.newsletterType === series,
        );
        return match ? [match] : [];
    });
